var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 64,
    viewBox: "0 0 74 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 15H1.5C0.671573 15 0 15.6716 0 16.5V53.5C0 54.3284 0.671571 55 1.5 55H58.5C59.3284 55 60 54.3284 60 53.5V26V16.5C60 15.6716 59.3284 15 58.5 15Z",
    fill: "#F2FCEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 9H7.5C6.67157 9 6 9.67157 6 10.5V47.5C6 48.3284 6.67157 49 7.5 49H64.5C65.3284 49 66 48.3284 66 47.5V20V10.5C66 9.67157 65.3284 9 64.5 9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20V10.5C66 9.67157 65.3284 9 64.5 9H7.5C6.67157 9 6 9.67157 6 10.5V47.5C6 48.3284 6.67157 49 7.5 49H41",
    stroke: "#5C5C5C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.832 23.6006L49 26.5293",
    stroke: "#5C5C5C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.168 23.6006L16 33.0006L26.168 23.6006Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.168 23.6006L16 33.0006",
    stroke: "#5C5C5C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0135 10.3701L39.6455 27.8635C37.4513 29.3783 34.549 29.3783 32.3548 27.8635L6.98682 10.3701",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0135 10.3701L39.6455 27.8635C37.4513 29.3783 34.549 29.3783 32.3548 27.8635L6.98682 10.3701",
    stroke: "#5C5C5C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 39C48 36.7909 49.7909 35 52 35H68C70.2091 35 72 36.7909 72 39V51C72 53.2091 70.2091 55 68 55H52C49.7909 55 48 53.2091 48 51V39Z",
    fill: "white",
    stroke: "#228800",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 23V23C55.5817 23 52 26.5817 52 31V35H68V31C68 26.5817 64.4183 23 60 23Z",
    stroke: "#228800",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60 44.0771C59.4477 44.0771 59 44.5249 59 45.0771C59 45.6294 59.4477 46.0771 60 46.0771C60.5523 46.0771 61 45.6294 61 45.0771C61 44.5249 60.5523 44.0771 60 44.0771",
    stroke: "#5C5C5C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "assets/media/email.f854ce2452422743c8bc96f7a3b68e10.svg";
export { ForwardRef as ReactComponent };